// 数字格式化，三位进制分隔
var formatNumber = function formatNumber(number) {
  var num = (number || 0).toString();
  var integer = num.split('.')[0]; // 整数部分
  var decimals = num.split('.')[1]; // 小数部分

  var result = '';
  while (integer.length > 3) {
    result = ',' + integer.slice(-3) + result;
    integer = integer.slice(0, integer.length - 3);
  }
  if (integer) {
    result = integer + result;
  }
  return result + (decimals ? '.' + decimals : '');
  // return num.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
};

var toMoney = function toMoney(val) {
  var reg = /,/gi;
  return this.formatNumber(val.replace(reg, "") * 1);
};
export default {
  formatNumber: formatNumber,
  toMoney: toMoney
};


//////////////////
// WEBPACK FOOTER
// ../vue-common-laboratory/dist/utils/number.js
// module id = null
// module chunks = 